import { HeadCell } from '../../../../../types'

export const headCellsOrders: HeadCell[] = [
  {
    id: 'displayId',
    numeric: true,
    label: 'order-id',
  },
  {
    id: 'customerName',
    numeric: false,
    label: 'customer',
  },
  {
    id: 'connectedReseller',
    numeric: false,
    label: 'reseller',
  },
  {
    id: 'jobName',
    numeric: false,
    label: 'job-title',
  },
  {
    id: 'status',
    numeric: false,
    label: 'status',
  },
  {
    id: 'place',
    numeric: false,
    label: 'place',
  },
  {
    id: 'createdAt',
    numeric: false,
    label: 'date-created',
  },
  {
    id: 'assignee',
    numeric: false,
    label: 'assignee',
  },
  {
    id: 'preview',
    numeric: false,
    label: 'preview',
  },
  {
    id: 'channel',
    numeric: false,
    label: 'portal',
  },
  {
    id: 'budget',
    numeric: false,
    label: 'budget',
  },
  {
    id: 'price',
    numeric: false,
    label: 'price',
  },
  {
    id: 'runtime',
    numeric: false,
    label: 'runtime',
  },
]
